import React from 'react'
import {Redirect } from 'react-router-dom'
import './login.css'
import Api from '../../services/api'
import Alert from '../../Components/alert/Alert'
import Allestec from '../../assets/new_logo_render.png'
import { text } from '@fortawesome/fontawesome-svg-core'

export default class ForgotPassword extends React.Component {

  state = {email:null, show: false, message: "",redirect:false, path: "/" }

  changeValueName = (value) => { this.setState({ email: value.target.value }) }
  callbackfunction = () => { this.setState({ show: false }) }

  handleKeyPress = (e) => {
    if(e.key === 'Enter'){
      this.validateEmail(e.target.value);
    }
  }

  validateEmail = (email) => {
    if (email !== null && email !=='') {
        Api.get('/send-recovery-email?email='+email).then(response=>{
            if(response.status !== 200){
              this.setState({ message: ''+response.data.error, show: true })
            }else{
              this.setState({redirect: true, path:"/redefinir-senha"})
            }
                

        }).catch(error=>{
            this.setState({ message: "Erro de conexão com o servidor", show: true })
        })
     
    } else {
      this.setState({ message: 'Necessário preencher o campo e-mail.', show: true })
    }
  }

  render() {

    const { show, message,redirect } = this.state
    if(redirect)
        return <Redirect to={this.state.path}></Redirect>

    return (
      <div className="login">
        {show ? <Alert show={show} message={message} parentCallback={this.callbackfunction} /> : null}

        <section className ="login-form" >
          <form className="form-sec-login" action="" autoComplete="off">
            <div className="title-login"><img style={{maxHeight:'240px',maxWidth:'270px'}} src={Allestec}></img></div>
            <p style={{textAlign: 'justify', width: '90%'}}>Digite o e-mail cadastrado na conta, para receber um link de redefinição.</p>
            <div className="input-block">
              <input
                autoFocus
                placeholder="E-mail"
                id="login-email"
                type="email"
                value={this.state.email}
                onChange={this.changeValueName}
                onKeyPress={this.handleKeyPress}
              />
            </div>
            <div className="spaceButton">
              <button className="btn-login" onClick={()=>this.validateEmail(this.state.email)}>Enviar</button>
            </div>
            <div className="spaceButton">
            <button type="submit" onClick={()=>this.setState({redirect:true})} className="btn-login" >Voltar </button>
            </div>
          </form>
          <div className='login-image-container'>
            <div className='login-image-gradient'></div>
            <div className='login-image'></div>
          </div>
        </section>
      </div>
    )
  }
}

